import React, { createContext, useContext } from 'react';

const DEFAULT_VALUES = {
  data: {}
};

// The reducer is used to update values for the context
// const reducer = (state, action) => {
//   switch (action.type) {
//     case "reset":
//       return DEFAULT_VALUES;
//     case "update":
//       return { ...state, ...action.data };
//     default:
//       return state;
//   }
// };

// CREATING THE CONTEXT
const PageContext = createContext();

// CREATING THE PROVIDER
export const PageProvider = (props) => {

  const { pageData, children } = props;
  const [providerData, setProviderData] = React.useState({
    // ready: false,
    data: {
      ...(DEFAULT_VALUES?.data || {}),
      ...(pageData || {})
      // add default data to your provider here
    }
  });
  const value = {
    ...(providerData || {}),
    setter: (key, value) => {
      setProviderData(cur => {
        if (typeof key === 'object') {
          return {
            ...(cur || {}),
            ...(key || {})
          };
        }

        return {
          ...(cur || {}),
          [key]: value
        };
      });
    }
  };
  // debugger;
  // let [state, dispatch] = useReducer(reducer, DEFAULT_VALUES);
  // let value = { state, dispatch };

  return (
    <PageContext.Provider
      value={value}
    >
      {children}
    </PageContext.Provider>
  );
};

export function usePage() {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error('usePage must be used within a PageProvider');
  }

  return context;
}

export { PageContext };
